/**
 * @file Re-exports the two factor authentication switch component.
 */
import TwoFactorAuthenticationSwitch from "./TwoFactorAuthenticationSwitch";

export default TwoFactorAuthenticationSwitch;
